import React from 'react';
import { GiRingedPlanet } from 'react-icons/gi';
import { Alert, Typography } from 'amphitheatre';

import { Card, TutText, TutorialTag } from '../Tutorials.styled';
import TutorialPage from '../TutorialPage';
import ImagePopup from '../../../ImagePopup';

import Pic1 from './pic1.png';
import Pic2 from './pic2.png';
import Pic3 from './pic3.png';
import Pic4 from './pic4.png';

const { Paragraph } = Typography;

const Step1: React.FunctionComponent = () => {
  return (
    <TutorialPage nobg title="Tutorial 1: P.I.G.I. Basics">
      <Card>
        <TutorialTag>
          <GiRingedPlanet />
          STEP 1
        </TutorialTag>
        <ImagePopup src={Pic1} alt="main menu" />
        <TutText>
          <Paragraph>
            The P.I.G.I main menu is the selection wheel on the bottom left of
            the screen.
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> STEP 2
        </TutorialTag>
        <ImagePopup src={Pic2} alt="controls" />
        <TutText>
          <Paragraph>
            Use the arrow keys or WASD to move your view up, down, left, and
            right. Q and E will rotate your view clockwise or counter clockwise.
          </Paragraph>
          <Paragraph>
            <Alert primary>
              Using the mouse wheel will zoom in or out. Shift will speed up
              these movements.
            </Alert>
          </Paragraph>
          <Paragraph>
            <Alert primary>
              The space bar will enable or disable free roaming mode.
            </Alert>
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> STEP 3
        </TutorialTag>
        <ImagePopup src={Pic3} alt="click planets" />
        <TutText>
          <Paragraph>
            Hover the mouse over the planets tab on the bottom left of the
            screen to bring it up and select your planet.
          </Paragraph>
        </TutText>
      </Card>
      <Card>
        <TutorialTag>
          <GiRingedPlanet /> STEP 4
        </TutorialTag>
        <ImagePopup src={Pic4} alt="click earth" />
        <TutText>
          <Paragraph>
            In the case of The Quest For Blue, we will select Earth. What you
            see on your screen is considered your scenario.
          </Paragraph>
        </TutText>
      </Card>
    </TutorialPage>
  );
};

export default Step1;
